export default {
    state: {
        quizStatus: 0,

        quizParam: {
            area: 0,
            style: 0,
            time: 0
        }
    },
    mutations: {
        quizPlus: (state) => {
            state.quizStatus++

        },
        quizMinus: (state) => {
            state.quizStatus--
        },
        quizClose: (state) => {
            state.quizStatus = 0
        },
        quizReset: (state) => {
            state.quizStatus = 1
            state.quizParam.time = 0
            state.quizParam.area = 0
            state.quizParam.style = 0
        },
    },
    actions: {
        plusQuiz ({commit}) {
            commit('quizPlus')
        },
        minusQuiz ({commit}) {
            commit('quizMinus')
        },
        closeQuiz ({commit}) {
            commit('quizClose')
        },
        resetQuiz ({commit}) {
            commit('quizReset')
        },
    },
    getters: {
        quizStat (state) {
            return state.quizStatus
        },
        paramQuiz (state) {
            return state.quizParam
        }
    }
}
